import statuses from '@/helpers/statuses'

const initialState = () => ({
  users: {},
  teams: {},
  meta: {
    loadingUser: statuses.IDLE,
    loadingTeam: statuses.IDLE
  }
})

export default api => ({
  state: initialState,

  getters: {
    feedbacksLoading: state => state.meta.loadingUser,
    isFeedbacksLoading: state => state.meta.loadingUser === statuses.LOADING,
    feedbacks: state => userId => state.users[userId] || [],

    feedbacksTeamLoading: state => state.meta.loadingTeam,
    isFeedbacksTeamLoading: state => state.meta.loadingTeam === statuses.LOADING,
    feedbacksTeam: state => teamId => state.teams[teamId] || []
  },

  mutations: {
    fetchFeedbacks: state => {
      state.meta.loadingUser = statuses.LOADING
    },

    fetchFeedbacksSuccess: (state, { userId, data }) => {
      state.meta.loadingUser = statuses.LOADED
      state.users = { ...state.users, [userId]: data }
    },

    fetchFeedbacksFailure: (state, error) => {
      state.meta.loadingUser = statuses.FAILED
    },

    fetchFeedbacksTeam: state => {
      state.meta.loadingTeam = statuses.LOADING
    },

    fetchFeedbacksTeamSuccess: (state, { teamId, data }) => {
      state.meta.loadingTeam = statuses.LOADED
      state.teams = { ...state.teams, [teamId]: data }
    },

    fetchFeedbacksTeamFailure: (state, error) => {
      state.meta.loadingTeam = statuses.FAILED
    },

    resetFeedbacks: state => {
      const payload = initialState()
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },

  actions: {
    fetchFeedbacks: async ({ commit }, userId) => {
      const slug = api.getWorkspaceSlug()
      commit('fetchFeedbacks')
      try {
        const data = await api.fetchFeedbacks(slug, userId)
        commit('fetchFeedbacksSuccess', { userId, data })
      } catch (error) {
        commit('fetchFeedbacksFailure', error)
      }
    },

    fetchTeamFeedbacks: async ({ commit }, teamId) => {
      const slug = api.getWorkspaceSlug()
      commit('fetchFeedbacksTeam')
      try {
        const data = await api.fetchFeedbacksTeam(slug, teamId)
        commit('fetchFeedbacksTeamSuccess', { teamId, data })
      } catch (error) {
        commit('fetchFeedbacksTeamFailure', error)
      }
    },

    clear: ({ commit }) => {
      commit('resetFeedbacks')
    }
  }
})
